


















import { Component, Vue } from "vue-property-decorator";
import PatientSearch from "@/components/patientsearch/PatientSearch.vue";
import { Collections } from "@/mixins/firestoreMixin";

@Component({
  components: {
    PatientSearch
  }
})
export default class PatientList extends Vue {
  // fire store 保存先コレクション
  private collection_name = Collections.SearchCondPatientList;

  private searchHintText =
    "以下の情報によって利用者を検索できます。\n\n" +
    "利用者名\n" +
    "利用者名ふりがな\n" +
    "電話番号\n" +
    "　基礎情報の電話番号・携帯電話番号\n" +
    "　キーパーソンの電話番号\n" +
    "利用者ID\n" +
    "介護保険の被保険者番号\n\n" +
    "※電話番号検索は、10桁か11桁の数字を入力してください";

  // 利用者選択
  private clickSelect(patientId: number) {
    this.$router.push(`/patient/${patientId}/calendar`);
  }

  // 新規利用者受付
  private clickAccept() {
    // 利用者登録
    this.$router.push(`/patient/accept`);
  }
}
